<div class="video-dialog-container">

    <div class="video-dialog-header">
        <h2 mat-dialog-title class="dialog-title">
            {{ data?.title || 'Video' }}
        </h2>

        <button
                mat-icon-button
                class="close-button"
                (click)="onClose()"
                aria-label="Close video"
                type="button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="video-dialog-content">
        <div class="video-wrapper">
            <iframe
                    *ngIf="safeVideoUrl"
                    [src]="safeVideoUrl"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    [title]="data?.title || 'Video'"
                    class="video-iframe"
                    webkitallowfullscreen
                    mozallowfullscreen>
            </iframe>
        </div>
    </mat-dialog-content>
</div>
